import { Getters } from 'vuex-smart-module';
import LastNotificationsState from './state';

export default class LastNotificationsGetters extends Getters<LastNotificationsState> {}
